import * as Sentry from '@sentry/react'

export enum BreadcrumbLevel {
  Debug = 'debug',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Fatal = 'fatal',
}

export enum BreadcrumbType {
  Default = 'default',
  Debug = 'debug',
  Error = 'error',
  Navigation = 'navigation',
  Http = 'http',
  Info = 'info',
  Query = 'query',
  Transaction = 'transaction',
  UI = 'ui',
  User = 'user',
}

type Props = {
  category?: string
  data?: {[key: string]: string | number | boolean}
  level?: BreadcrumbLevel
  message: string
  type?: BreadcrumbType
}

const addTrackingBreadcrumb = (props: Props) => {
  try {
    if (!props.type) {
      props.type = BreadcrumbType.Default
    }

    if (!props.level) {
      props.level = BreadcrumbLevel.Info
    }

    Sentry.addBreadcrumb(props)
  } catch (error) {
    console.error(error)
  }
}

export default addTrackingBreadcrumb
